import React from 'react';
import ArchitectureLayout from 'components/architecture/ArchitectureLayout';

/**
 * Runtime Architecture Page
 * Documents the runtime execution enviroment
 */
const Runtime = () => {
  const sections = [
    {
      id: 'overview',
      title: 'Runtime Overview',
      content: `Our runtime enviroment is built on **Azure Functions**, a serverless compute service that enables us to build and deploy event-driven applications and microservices.

The runtime provides:
- Automatic scaling based on demand
- Pay-per-use pricing model
- Built-in integration with Azure services
- Support for multiple programming languages (Python, JavaScript, C#)
- Event-driven architecture for real-time processing`
    },
    {
      id: 'execution-model',
      title: 'Execution Model',
      content: `Our functions are executed in a serverless enviroment that:

1. **Automatically scales** from zero to thousands of instances
2. **Handles load balancing** across multiple instances
3. **Manages resource allocation** dynamically
4. **Provides isolation** between function executions
5. **Supports long-running operations** through durable functions

\`\`\`mermaid
graph TD
    A[API Request] --> B[API Gateway]
    B --> C[Backend API]
    C --> D[Function Execution]
    D --> E[MongoDB]
    D --> F[Key Vault]
    D --> G[Storage]
    E --> H[Response]
    F --> H
    G --> H
\`\`\``
    },
    {
      id: 'function-types',
      title: 'Function Types',
      content: `We use several types of Azure Functions:

- **HTTP Triggers**: Handle REST API requests
- **Timer Triggers**: Execute scheduled tasks
- **MongoDB Change Feed Triggers**: Process database changes in real-time
- **Queue Triggers**: Process background jobs
- **Event Hub Triggers**: Handle high-throughput event streams`
    },
    {
      id: 'performance',
      title: 'Performance & Scaling',
      content: `The runtime automatically scales based on:

- **Request rate**: More requests trigger more instances
- **Execution time**: Long-running functions may use dedicated instances
- **Resource utilization**: CPU and memory usage drive scaling decisions

All scaling happens automatically without manual intervention.`
    }
  ];

  return (
    <ArchitectureLayout
      title="Runtime"
      lastUpdated="2025-01-15"
      sections={sections}
    />
  );
};

export default Runtime;

